var _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThreeArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 22,
    viewBox: "0 0 40 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1458 1.77079L40 10.625L31.1458 19.4791L29.5742 17.9075L36.8568 10.625L29.5742 3.34241L31.1458 1.77079Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_1389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0208 1.77079L31.875 10.625L23.0208 19.4791L21.4492 17.9075L28.7318 10.625L21.4492 3.34241L23.0208 1.77079Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_252_1389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3958 1.77079L21.25 10.625L12.3958 19.4791L10.8242 17.9075L18.1068 10.625L10.8242 3.34241L12.3958 1.77079Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_1389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.25,
    height: 21.25,
    fill: "white",
    transform: "translate(31.875 21.25) rotate(180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_252_1389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.25,
    height: 21.25,
    fill: "white",
    transform: "translate(21.25 21.25) rotate(180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeArrows);
export default __webpack_public_path__ + "static/media/three-arrows.8dd1209978a5c32847d2343e9e6244b9.svg";
export { ForwardRef as ReactComponent };